@if (workspaces && workspaces.length) {
  <div class="workspaces-select">
    <ds-input [label]="'change_workspace' | translate">
      <select
        ds-input-field
        data-test-id="workspaces-select"
        [(ngModel)]="selectedWorkspaceId"
        (ngModelChange)="selectWorkspace($event)"
      >
        @for (workspace of workspaces; track workspace[$workspace._id]) {
          <option [value]="workspace[$workspace._id]">
            {{ workspace[$workspace.name] }}
          </option>
        }
      </select>
    </ds-input>
  </div>
}
